import React, { Component } from 'react';
import './login.scss';
import { autoExternalLogin } from '../../ActionCreators/loginAction';
import { clearErrors } from '../../ActionCreators/errorAction';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Lottie from 'react-lottie';
import animationData from '../../assets/loader.json';

class ExternalLogin extends Component {
    state = {
        defaultShow: true,
        email: '',
        password: '',
        quoteSelected: [],
        resetPasswordComplete: false,
        newPassword: '',
        otp: '',
        resetComplete: false,
        otpEnable: false,
        isResetPassword: false,
        emailOtpScreen: true,
        isOtpEmailLoading: false,
        isOtpResetLoading: false,
        lang: ''
    }

    componentDidMount = () => {
        axios.get(process.env.REACT_APP_API_KEY + "company/logo").then((response) => {
            if (response.data.success) {
                this.setState({
                    logo: response.data.logo,
                }, () => {
                    localStorage.setItem('logo', response.data.logo)
                    localStorage.setItem('company', response.data.company_name)
                })
            }
        });


        if (window.location.href.includes("auto")) {
            this.checkUserAuth();
        }


        if (localStorage.getItem('profileComplete') === 'false') {
            this.props.history.push('/add-skills')
        }
        else {
            if (localStorage.getItem('role') !== null && (localStorage.getItem('role')?.includes('user') || localStorage.getItem('role')?.includes('admin'))) {
                if (localStorage.getItem('loginToken') !== null) {
                    (window.location.pathname === '/' || window.location.pathname === '/login') &&
                        this.props.history.push('/learn')
                }
                else {
                    (window.location.pathname === '/' || window.location.pathname === '/login') &&
                        this.props.history.push('/login')
                }
            }
        }

    }

    async checkUserAuth() {
        if (window.location.href.includes("auto")) {
            this.setState({
                isLoading: true
            })
            const code = window.location.href.split('?')[1].split('=')[1]
            await this.props.autoExternalLogin(code);
            setTimeout(() => {
                if (this.props.successMessage === true) {
                    this.setState({
                        isLoading: false
                    })
                }
            }, 1000);
        }
    }





    snackClosed1 = () => {
        this.props.clearErrors()
    }

    render() {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return (
            <div className='login-module'>

                {
                    this.props.isLoading ?
                        <div className='login-loader'>
                            <Lottie options={defaultOptions}
                                height={400}
                                width={400}
                                isStopped={this.state.isStopped}
                                isPaused={this.state.isPaused} />
                        </div>
                        : null

                }
                {
                    this.props.successMessage ?
                        <div className='login-holder text-center' style={{ padding: '15px 45px' }}>
                            <h3>{this.props.mesg}</h3>
                        </div>
                        : null
                }

            </div>
        )
    }
}


const mapStateToProps = (state) => {
    const { isLoading, mesg } = state.login
    const { successMessage, successMessageText, successEnable } = state.error
    return {
        successMessage,
        successMessageText,
        successEnable,
        isLoading, mesg
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ autoExternalLogin, clearErrors }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExternalLogin))
